export const chunkArray = <T>(array: T[], size: number): T[][] => {
  const arr: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    const chunk = array.slice(i, i + size);
    arr.push(chunk);
  }
  return arr;
};
